import React from 'react';
import { EngagementChart } from './EngagementChart';

import { GetPostStatsLazyQueryHookResult } from '../../../../models/graphql';
import { EngagementOnPostChart } from './EngagementOnPostChart';
import { BestTimeToPost } from './BestTimeToPostChart';

type EngagementViewProps = {
  data: GetPostStatsLazyQueryHookResult[1]['data'];
  loading: boolean;
  showBestTime: boolean;
};
export const EngagementView = ({ data, loading, showBestTime }: EngagementViewProps) => {
  return (
    <>
      {/* If we show best time (i.e. Analyze per Profile), do not show the Total Engagements */}
      {!showBestTime && (
        <div className={'grid-x grid-margin-x grid-margin-y'}>
          <EngagementChart data={data} loading={loading} />
        </div>
      )}
      <div className={'grid-x grid-margin-x grid-margin-y'}>
        <EngagementOnPostChart data={data} loading={loading} />
      </div>
      {showBestTime && (
        <div className={'grid-x grid-margin-x grid-margin-y'}>
          <BestTimeToPost />
        </div>
      )}
    </>
  );
};
